import {pluralize} from "@pg-mono/string-utils";

export const roomsPlural = pluralize(["pokój", "pokoje", "pokoi"]);
import {pluralize} from "@pg-mono/string-utils";

export const roomsPlural = pluralize(["pokój", "pokoje", "pokoi"]);
